<template>
  <div>
    <van-dialog
      v-model="dialogModel"
      show-cancel-button
      :confirmButtonText="$t('confirm.msg_fail_confirm')"
      :cancelButtonText="$t('confirm.msg_fail_cancel')"
      :before-close="onPayment"
    >
      <div class="pay-popup" v-if="payMode.includes('Mobile')">
        <van-row class="card-payment">
          <template v-if="payMode.includes('Toumkap')">
            <van-field
              type="number"
              v-model="payInfo.phone"
              class="pay-popup-phone"
              :placeholder="$t('login.phone_number')"
            />
            <!-- <van-field
              class="card-payment-email"
              v-model="payInfo.email"
              :placeholder="$t('order.enter_order_email')"
            /> -->
          </template>
          <template v-else>
            <div class="pay-popup-number">
              <div class="area" @click="isAreaView = true">
                <span>+{{ payInfo.areaCode }}</span>
                <div class="area-down"></div>
              </div>
              <van-field
                type="number"
                v-model="payInfo.phone"
                class="pay-popup-phone"
                :placeholder="$t('login.phone_number')"
              />
            </div>
          </template>
        </van-row>
      </div>
      <div class="pay-popup" v-else>
        <van-row class="card-payment">
          <van-field
            type="number"
            maxlength="19"
            placeholder="card number"
            class="card-payment-number"
            v-model="payInfo.cardNumber"
          />
          <van-row>
            <van-col span="13">
              <van-col span="11">
                <van-field
                  type="number"
                  maxlength="2"
                  placeholder="MM"
                  v-model="payInfo.expiryMonth"
              /></van-col>
              <van-col span="1"></van-col>
              <van-col span="11">
                <van-field
                  type="number"
                  maxlength="2"
                  placeholder="YY"
                  v-model="payInfo.expiryYear"
              /></van-col>
            </van-col>
            <van-col span="1"></van-col>
            <van-col span="10">
              <van-field
                type="number"
                maxlength="3"
                placeholder="CVV"
                v-model="payInfo.cvv"
              />
            </van-col>
          </van-row>
          <van-field
            class="card-payment-email"
            v-model="payInfo.email"
            :placeholder="$t('order.enter_order_email')"
          />
        </van-row>
      </div>
    </van-dialog>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SelectArea } from "../select";
export default {
  name: "FlutterwavePay",
  props: {
    payMode: {},
    dialogPopup: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SelectArea
  },
  watch: {
    dialogPopup(val) {
      this.dialogModel = val;
    }
  },
  computed: {
    ...mapState(["system", "user"]),
    i18n() {
      return this.$t("confirm");
    }
  },
  data() {
    return {
      dialogModel: false,
      isAreaView: false,
      payInfo: {
        show: false,
        phone: "", // "911234567",
        email: "",
        areaCode: "95",
        cardNumber: "",
        expiryMonth: "",
        expiryYear: "",
        cvv: ""
      }
    };
  },
  methods: {
    onSelct(val) {
      this.payInfo.areaCode = val;
    },
    // 手机号码
    Flutterwave_Mobile(done) {
      const fieldValues = { ...this.payInfo };
      if (!fieldValues.phone) {
        this.$toast(this.$t("msg.msg_none_mobile"));
        return done(false);
      }
      // if (this.payMode.includes("Toumkap") && !fieldValues.email) {
      //   this.$toast(this.$t("order.enter_order_email"));
      //   return done(false);
      // }
      this.payInfo = { ...fieldValues, phone: "" };
      this.$emit("onPayment", { show: false, ...fieldValues });
      done();
    },
    // Flutterwave Card支付
    Flutterwave(done) {
      const fieldValues = { ...this.payInfo };
      if (!fieldValues.cardNumber) {
        this.$toast(`请输入 cardNumber`);
      } else if (!fieldValues.expiryMonth) {
        this.$toast(`请输入 expiryMonth`);
      } else if (!fieldValues.expiryYear) {
        this.$toast(`请输入 expiryYear`);
      } else if (!fieldValues.cvv) {
        this.$toast(`请输入 cvv`);
      } else {
        this.payInfo = {
          ...fieldValues,
          cvv: "",
          cardNumber: "",
          expiryMonth: "",
          expiryYear: ""
        };
        this.$emit("onPayment", { show: false, ...fieldValues });
        return done();
      }
      return done(false);
    },
    // 确认支付
    onPayment(action, done) {
      if (action === "confirm") {
        if (this.payMode.includes("Mobile")) {
          this.Flutterwave_Mobile(done);
        } else {
          this.Flutterwave(done);
        }
      } else if (action === "cancel") {
        this.$emit("onPayment", { show: false, cancel: true });
        done();
      }
    }
  },
  created() {
    if (this.user && this.user.email) {
      this.payInfo.email = this.user.email;
    }
  }
};
</script>

<style lang="less" scoped>
.pay-popup {
  margin: 64px 0 32px;
  padding: 24px 46px;
  &-number {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding-left: 24px;
    border-radius: 16px;
    border: 1px solid #ccc;
    overflow: hidden;
    .van-cell {
      border: none !important;
    }
  }
  &-phone {
    font-size: 32px;
  }
}

.card-payment {
  width: 100%;
  .van-cell {
    border: 1px solid #ccc;
    border-radius: 12px;
  }
  &-number {
    margin-bottom: 28px;
  }
  &-email {
    margin-top: 28px;
  }
}
</style>
